import { render, staticRenderFns } from "./CampaignDateTime.vue?vue&type=template&id=770588c6&scoped=true"
import script from "./CampaignDateTime.vue?vue&type=script&lang=js"
export * from "./CampaignDateTime.vue?vue&type=script&lang=js"
import style0 from "./CampaignDateTime.vue?vue&type=style&index=0&id=770588c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770588c6",
  null
  
)

export default component.exports